import type { SwitchStatusProps, SwitchStatusValueLabels } from './types';
import {
  Switch,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import React from 'react';
import SetupGridItem from '../../containers/ViewProperty/SetupGridItem';
import OnOffTypography from '../../containers/ViewProperty/OnOffTypography';

export default function SwitchStatus(props: SwitchStatusProps) {
  const ValueLabel = ({
    checked,
    unchecked,
    isChecked,
  }: SwitchStatusValueLabels & { isChecked: boolean }) => {
    return (
      <OnOffTypography on={!props.disabled}>
        {isChecked ? checked : unchecked}
      </OnOffTypography>
    );
  };

  const ValueLabelWithTooltip = (
    labelProps: SwitchStatusValueLabels & { isChecked: boolean },
  ) => {
    return props.tooltip ? (
      <Tooltip title={props.tooltip} placement={'top'}>
        <ValueLabel {...labelProps} />
      </Tooltip>
    ) : (
      <ValueLabel {...labelProps} />
    );
  };

  const showInlineValueLabel = Boolean(
    props.showLabelEdit && props.valueLabels,
  );

  return (
    <SetupGridItem label={props.label}>
      {props.enableEdit ? (
        <>
          <Switch {...props.switchProps} disabled={props.disabled} />
          {showInlineValueLabel && (
            <ValueLabelWithTooltip
              {...props.valueLabels}
              isChecked={!!props.switchProps.checked}
            />
          )}
        </>
      ) : (
        <ValueLabelWithTooltip
          {...props.valueLabels}
          isChecked={!!props.switchProps.checked}
        />
      )}
    </SetupGridItem>
  );
}
